module.exports = __webpack_public_path__ + "img/twilio-icon.9cbf8f82.svg";